export const documentBuilderConstants = {
  DOCUMENT_BUILDER_ADD_DATA: 'DOCUMENT_BUILDER_ADD_DATA',
  DOCUMENT_BUILDER_SET_HEADER_TEXT: 'DOCUMENT_BUILDER_SET_HEADER_TEXT',
  DOCUMENT_BUILDER_SET_BOLD: 'DOCUMENT_BUILDER_SET_BOLD',
  DOCUMENT_BUILDER_SET_FONT_SIZE: 'DOCUMENT_BUILDER_SET_FONT_SIZE',
  DOCUMENT_BUILDER_SET_EDIT_QUESTION: 'DOCUMENT_BUILDER_SET_EDIT_QUESTION',
  DOCUMENT_BUILDER_REMOVE_DATA: 'DOCUMENT_BUILDER_REMOVE_DATA',
  DOCUMENT_REARRANGE_ITEMS: 'DOCUMENT_REARRANGE_ITEMS',
  DOCUMENT_RESET_IDS: 'DOCUMENT_RESET_IDS',
  DOCUMENT_RESET: 'DOCUMENT_RESET',
  DOCUMENT_GET_SUCCESS: 'DOCUMENT_GET_SUCCESS',
  DOCUMENT_ONLY_ANSWER: 'DOCUMENT_ONLY_ANSWER',
  DOCUMENT_REMOVE_QUESTION: 'DOCUMENT_REMOVE_QUESTION',

  DOCUMENT_INCREMENT_LINKID: 'DOCUMENT_INCREMENT_LINKID',
  DOCUMENT_DECREMENT_LINKID: 'DOCUMENT_DECREMENT_LINKID'
}